import { css } from 'styled-components';

export const DemandRoleSummaryEventStyles = css`
  .b-sch-event-wrap.demand_role {
    height: 40px;

    .b-sch-event {
      border-radius: 0px;
    }
    &.over-allocated {
      .b-sch-event {
        background-color: var(--red-90);
        border-color: var(--red-90);
        &.b-sch-event-selected .b-sch-event-content .content,
        .content {
          color: var(--red-10) !important;
        }
      }
    }
    &.mostly-allocated {
      .b-sch-event {
        background-color: var(--blue-80);
        border-color: var(--blue-80);
        &.b-sch-event-selected .b-sch-event-content .content,
        .content {
          color: var(--blue-10) !important;
        }
      }
    }
    &.moderately-allocated {
      .b-sch-event {
        background-color: var(--blue-50);
        border-color: var(--blue-50);
        &.b-sch-event-selected .b-sch-event-content .content,
        .content {
          color: var(--blue-90) !important;
        }
      }
    }
    &.mildly-allocated {
      .b-sch-event {
        background-color: var(--blue-20);
        border-color: var(--blue-20);
        &.b-sch-event-selected .b-sch-event-content .content,
        .content {
          color: var(--blue-80) !important;
        }
      }
    }
    &.sparsely-allocated {
      .b-sch-event {
        background-color: var(--green-10);
        border-color: var(--green-20);
        &.b-sch-event-selected .b-sch-event-content .content,
        .content {
          color: var(--green-80) !important;
        }
      }
    }
    &.no-capacity {
      .b-sch-event {
        background-color: var(--purple-10);
        border-color: var(--purple-10);
        &.b-sch-event-selected .b-sch-event-content .content,
        .content {
          color: var(--purple-70) !important;
        }
      }
    }
    .b-sch-event-content,
    &.b-sch-event-selected .b-sch-event-content {
      width: unset;

      .content {
        width: unset;
        font-weight: var(--font-weight-bold) !important;
      }
    }
  }
`;
export const DemandEventStyles = css`
  .b-sch-event-wrap {
    &.demand_capacity,
    &.total_allocation,
    &.user_total_allocation,
    &.user_total_soft_allocation,
    &.user_total_hard_allocation,
    &.team_total_allocation,
    &.team_total_soft_allocation,
    &.team_total_hard_allocation {
      height: 48px;
      .b-sch-event {
        border-radius: 0px;
        background: transparent !important;
        border-color: transparent !important;
      }
      &.over-allocated {
        .b-sch-event {
          background: var(--red-10) !important;
          border-color: var(--red-10) !important;
        }
      }
      .b-sch-event-content {
        width: unset;

        .content {
          width: unset;
        }
      }
    }

    &.user_total_allocation,
    &.user_total_soft_allocation,
    &.user_total_hard_allocation,
    &.team_total_allocation,
    &.team_total_soft_allocation,
    &.team_total_hard_allocation {
      .content {
        color: var(--gray-70) !important;
        .secondary-text {
          color: var(--gray-50) !important;
        }
      }
    }

    &.demand_capacity,
    &.user_total_allocation,
    &.user_total_soft_allocation,
    &.user_total_hard_allocation,
    &.team_total_allocation,
    &.team_total_soft_allocation,
    &.team_total_hard_allocation {
      .b-sch-event {
        cursor: default;
      }
    }
  }
`;

export const DemandGridStyles = css`
  .b-gridbase .b-grid-subgrid-normal {
    .user_total_allocation,
    .user_total_soft_allocation,
    .user_total_hard_allocation,
    .team_total_allocation,
    .team_total_soft_allocation,
    .team_total_hard_allocation {
      &.b-grid-row {
        border-bottom-color: var(--coolest-gray-10);
        .b-grid-cell {
          background: var(--coolest-gray-10) !important;
        }
      }
    }
    .demand_capacity,
    .total_allocation {
      &.b-grid-row {
        border-bottom-color: var(--border-color);
      }
    }
  }
  .b-grid-row.b-tree-parent-row.total_allocation {
    .b-tree-cell-inner {
      padding-left: 0.7em !important;
    }
  }
`;

export const DemandViewPresetStyles = css`
  .b-schedulerpro[data-preset-id|='month'],
  .b-schedulerpro[data-preset-id|='week'] {
    .b-column-lines-canvas .b-column-line {
      border-left-width: 0;
    }
  }
`;
